/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_user = {
    readonly canRequestShippingQuotePermission: boolean | null;
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user">;
    readonly " $refType": "PdpSharedShippingInfoLink_user";
};
export type PdpSharedShippingInfoLink_user$data = PdpSharedShippingInfoLink_user;
export type PdpSharedShippingInfoLink_user$key = {
    readonly " $data"?: PdpSharedShippingInfoLink_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoLink_user",
  "selections": [
    {
      "alias": "canRequestShippingQuotePermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_REQUEST_SHIPPING_QUOTE"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '061d18e2a415632e7eaed801dc973c2e';
export default node;
